import Form from "./forms/form";
 export default function FootContact(setThankModal, toggleModal, id )
{
    const title="Alright! Let’s Get to Work ";
    return(
<>
    <style>{`.Form-foot button{background: linear-gradient(90deg,#F16500 0%,#FF9A3E 100%);}
    .Form-foot button:hover{background: linear-gradient(90deg,#F16500 0%,#d16400 100%);}
    ` }
    

    </style>
          <section className="section-1 py-[60px] bg-[#F6FAFF]">
            <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
                <div className="text-center">
                    <h1 className='lg:text-[55px]  text-[35px]  mb-0 font-bold text-[#262626] relative inline-block'>{title} <span className=" rounded-[20px] w-[80px] m-auto h-[5px] bg-[#FB802C] block"></span></h1>
                </div>
                <div className="flex  lg:flex-row flex-col-reverse md:flex-row bg-gradient-to-r from-[#656BFB]  to-[#2725BC] rounded-[32px] relative mt-[60px]" data-aos="fade-up"   data-aos-offset='150'  data-aos-duration= "650"> 
                <div className="absolute inset-0 opacity-30" style={{background: "url('https://glocify.com/images/bgform.png')", backgroundSize:'cover', backgroundRpeat:'no-repat',mixBlendMode:'multiply'}}></div>
                    <div style={{backgroundImage: 'linear-gradient(to bottom, rgba(213, 205, 193, 0.73) 33%, rgba(255, 255, 255, 0) 0%)', backgroundPosition:'right', backgroundSize:'1px 12px', backgroundRepeat:'repeat-y'}} className="lg:w-[calc(100%-420px)] md:w-[60%] w-full lg:px-[45px] lg:py-[40px] md:py-[30px] px-[30px] pb-[30px] z-20" >
                    <h3 className="font-semibold text-white text-[30px] leading-tight tracking-tight">Fill out the form & let’s get started!!! 
                        </h3>
                        <h2 className="text-[15px] font-regular text-white mb-4 leading-normal tracking-tight mt-[10px]">Hire an expert Stripe developer for all your Stripe integration needs, whether it's for web, mobile, or hardware applications.</h2>
                        <ul className="flex flex-wrap flex-col gap-y-[25px] mt-[45px]">
                            <li className="flex items-center gap-[20px]">
                                <div><img src="https://glocify.com/images/email.svg"></img></div>
                                <div className="w-[75%]">
                                    <label className="block text-[20px] text-white font-semibold">Email Address</label>
                                    <a href="mailto:Info@glocify.com" className="text-[16px] font-regular text-white">Info@glocify.com</a>
                                </div>
                            </li>
                            <li className="flex items-center gap-[20px]">
                            <div><img src="https://glocify.com/images/contact.svg"></img></div>
                            <div className="w-[75%]">
                                    <label  className="block text-[20px] text-white font-semibold">Call Now</label>
                                    <a className="text-[16px] font-regular text-white" href="callto:8288090864">+1 216 208 8072</a>
                                </div>
                            </li>
                             <li className="flex items-center gap-[20px]">
                            <div><img src="https://glocify.com/images/linked.svg"></img></div>
                            <div className="w-[75%]">
                                    <label  className="block text-[20px] text-white font-semibold">Linkedin</label>
                                    <a className="text-[16px] font-regular text-white decoration-2 decoration-white" href="https://shorturl.at/t4sJA">Let's connect on Linkedin</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="Form-foot lg:w-[420px] w-full md:w-[40%] lg:px-[45px] lg:py-[40px] z-20 p-[30px]">
                        <h3 className="font-semibold text-white text-[26px] pb-[10px]">
                        Hire a Stripe Expert Today!
                        </h3>                        
                        <Form contactformid="15387" setThankModal={setThankModal} /></div>
                </div>
                <ul className="flex justify-between max-w-[650px] mx-auto gap-x-[20px] mt-[50px]">
                    <li><img src="https://glocify.com/images/cert1.png"/></li>
                    <li><img src="https://glocify.com/images/cert2.png"/></li>
                    <li><img src="https://glocify.com/images/cert3.png"/></li>
                    <li><img src="https://glocify.com/images/cert4.png"/></li>

                </ul>
            </div>            
        </section>
        </>
 
    )
}